import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { filter, map, take } from 'rxjs/operators';
import { toObservable } from '@angular/core/rxjs-interop';

export const authGuard: CanActivateFn = () => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  // If already ready, check immediately
  if (auth.ready()) {
    if (auth.isLoggedIn()) return true;
    router.navigate(['/landing']);
    return false;
  }

  // Wait for MSAL to finish initializing before checking
  return toObservable(auth.ready).pipe(
    filter((ready) => ready),
    take(1),
    map(() => {
      if (auth.isLoggedIn()) return true;
      router.navigate(['/landing']);
      return false;
    })
  );
};